<div class="  inset-0">

    <div class="flex flex-col flex-auto  h-full  ">


        <div *ngIf="!isChineseSystem()" style="line-height: 1.6; border-radius: 8px;">
            <p style="font-weight: bold; font-size: 1.1rem;">Dear BHive Member,</p>

            <p>
                We’re excited to share some important updates! As part of our ongoing commitment to improve your
                experience,
                we’ve made enhancements to the <strong>chemical inventory builder</strong> to streamline and simplify
                your Chemical Management process.
            </p>

            <h3 style="font-weight: bold; margin-top: 2rem;">What’s New?</h3>
            <ul style="margin-left: 1rem;">
                <li>All tools related to chemical data are now organized under the <strong>‘Chemical
                        Management’</strong> section – including <strong>Chemical Inventory</strong> and <strong>My Chem
                        Store</strong>.</li>
                <li>The <strong>inventory builder</strong> process has been simplified from <strong>5 steps to just
                        3</strong>, making it faster and easier to complete.</li>
                <li><strong>Navigation has been improved</strong>, so you can now move freely between different steps as
                    you work.</li>
                <li><strong>Mandatory fields</strong> are now <strong>color-coded</strong>, making it easier to spot and
                    address any missing information.</li>
                <li>Avoid uploading the same chemical multiple times with The BHive’s <strong>duplicate alert</strong>.
                </li>
                <li>After publishing your chemicals, you can easily find chemicals in your CIL thanks to our new
                    <strong>inventory search function</strong>.
                </li>
            </ul>

            <h4 style="margin-top: 2rem; font-weight: bold;">Learn how to use the new features:</h4>
            <p>
                Check out our walkthrough videos and guideline to see the latest features in action and how they can
                help you work more efficiently:
            </p>

            <a href="https://cloud.goblu.net/s/DMKg6PSzGMMxTkF" target="_blank">
                The BHive® Update: Simplified Upload Flow - July 2025
            </a>

            <p style="margin-top: 2rem;">
                Thank you for being part of The BHive community!
            </p>

            <p><strong>Warm regards,<br>The BHive Team</strong></p>
        </div>


        <div *ngIf="isChineseSystem()">
            <p style="font-weight: bold; font-size: 1.1rem;">尊敬的 BHive 会员：</p>

            <p>我们很高兴与您分享一些重要更新！</p>

            <p>为了持续提升您的体验，我们对化学品库存创建流程作了改进，简化您的化学品管理流程。</p>

            <h3 style="  font-weight: bold; margin-top: 2rem;">新功能：</h3>
            <ul style="margin-left: 1rem;">


                <li>所有与化学品数据相关的工具现在都归入“化学品管理”版块，包括“化学品库存”和“我的化学商店”。</li>

                <li>库存创建流程从原来的 6 个步骤简化为 3 个步骤，更快、更轻松地完成。</li>

                <li>导航功能也已改进，您现在可以在不同步骤之间自由切换。</li>

                <li>必填字段现在采用彩色编码，方便您查找和修改缺失信息。</li>

                <li>新设 BHive 的重复警报功能，避免多次上传同一种化学品。</li>

                <li>发布化学品后，您可以借助我们全新的库存搜索功能，轻松在 CIL 中找到所需的化学品。</li>
            </ul>

            <h4 style="margin-top: 2rem; font-weight: bold;">了解如何使用新功能：</h4>
            <p>
                观看我们的演示视频和指南，可了解最新功能的实际应用以及它们如何帮助您提高工作效率：
            </p>

            <a href="https://cloud.goblu.net/s/DMKg6PSzGMMxTkF" target="_blank">
                The BHive® Update: Simplified Upload Flow - July 2025
            </a>

            <p style="margin-top: 2rem;">感谢您加入 BHive 社群！</p>
            <br><br>
            <p><strong>此致敬礼，<br>BHive 团队</strong></p>
        </div>



    </div>



    <br>

    <div class="flex" style="justify-content: center;">
        <button class="  mt-4   choose-button " (click)="dialogRef.close(true)">
            {{isChineseSystem()?'确认知悉！':'Got it! '}}
        </button>
        &nbsp; &nbsp;


        <button class="mt-4 btn btn-primary" (click)="dialogRef.close(false)">
            {{isChineseSystem()?'请再次提醒我。':'Remind me again'}}
        </button>
    </div>
</div>